import {CreditScore, Person, Groups} from "@mui/icons-material";

const icons = { CreditScore, Person, Groups }

const buro = {
    id: 'buro',
    type: 'group',
    children: [
        {
            id: 'buro-menu',
            title: 'Buró',
            type: 'collapse',
            icon: icons.CreditScore,

            children: [
                {
                    id: 'cintaPM',
                    title: 'Cinta PM',
                    requiredPermission: 'Cinta',
                    type: 'item',
                    icon: icons.Groups,
                    url: '/buro/buroPM',
                    target: false
                },
                {
                    id: 'cintaPF',
                    title: 'Cinta PF',
                    requiredPermission: 'Cinta PF',
                    type: 'item',
                    icon: icons.Person,
                    url: '/buro/buroPF',
                    target: false
                }
            ]
        }
    ]
};

export default buro;